import { render, staticRenderFns } from "./DetailsComposante.vue?vue&type=template&id=bc197faa"
import script from "./DetailsComposante.vue?vue&type=script&lang=js"
export * from "./DetailsComposante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports